module.exports = __webpack_public_path__ + "img/CS-UL-I_Overview-Spare_1.0a4d5ab6.jpg";